<template>
  <div
    class="bg-card"
    :style="{ backgroundImage: `url(${background})` }"
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
  >
    <!-- 中心图片 -->
    <transition name="fade">
      <img
        v-if="!isHover"
        class="center-img"
        :src="centerImage"
        alt="center"
      />
    </transition>

    <!-- 中心文字 -->
    <transition name="fade">
      <div v-if="isHover" class="center-text" :style="{ color: index % 2 === 0 ? '#fff' : '#000' , textShadow: index %2===0?'0 2px 8px rgba(0, 0, 0, 0.6)':'0 2px 8px rgba(255,255,255,0.7)' }">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  background: String,
  centerImage: String,
  index: {            // 可选，默认 0
    type: Number,
    default: 0
  }
})

const isHover = ref(false)
</script>

<style scoped>
.bg-card {

  height: 100%;
  /* 正方形比例 */
  position: relative;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  border-radius: 2px;
  overflow: hidden;
}

/* 中心图片 */
.center-img {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 95.8%;                    /* 可改成 vw 单位 */
  height: 46%;
  object-fit: cover;
  transition: opacity 0.3s;
}

/* 中心文字 */
.center-text {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 95%;
  height: 46%;
  display: flex;                /* 关键 */
  align-items: center;          /* 垂直居中 */
  justify-content: center;      /* 水平居中 */
  color: #fff;
  font-size: 0.8vw;
  font-weight: normal;
  text-align: center;           /* 多行文本也居中 */
  transition: opacity 0.3s;
}

/* 淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
@media (max-width: 768px) {
  .center-text{
    font-size: 1.6vw;
  }
}
</style>
